import {
    LOGIN,
    BASE_URL
} from '@/services/api'
import { post,get } from "@/utils/request";

/**
 * 弱密码
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function getWeak() {
    return get(`${BASE_URL}/ext/weak`)
}

/**
 * 登录-用户名密码
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function doLogin(param) {
    return post(`${LOGIN}/doLogin`, param)
}

/**
 * 登录-手机号
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function doMobile(param) {
    return post(`${LOGIN}/doMobile`, param)
}

/**
 * 登录-验证码
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function aiCaptcha() {
    return post(`${LOGIN}/captcha`)
}

/**
 * 登录-手机号-短信
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function doMobilecCode(param) {
    return post(`${LOGIN}/doMobile/code`,param)
}

/**
 * 登录-引导修改密码
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function expired(param) {
    return post(`${LOGIN}/expired`,param)
}


/**
 * 忘记密码-第一步
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function forgetPhone(param) {
    return post(`${LOGIN}/forget/phone`,param)
}


/**
 * 忘记密码-第二步
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function forgetMod(param) {
    return post(`${LOGIN}/forget/mod`,param)
}

/**
 * 忘记密码-发送短信
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function forgetSend(param) {
    return post(`${LOGIN}/forget/send`,param)
}

/**
 * 用户信息完善
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function postReg(param) {
    return post(`${LOGIN}/reg`,param)
}

/**
 * 获取登录小程序码
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function qrCode() {
    return get(`${LOGIN}/weChat/mini/login/qrCode`)
}

/**
 * 第一步-请求CODE链接
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function codeUrl() {
    return get(`${LOGIN}/wx/web/auth2/codeUrl/state`)
}

/**
 * 第二步-accessToken
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function accessToken(code,state) {
    return get(`${LOGIN}/wx/web/auth2/accessToken/${code}/${state}`)
}

/**
 * 第二步-accessToken
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function woauth(param) {
    return post(`${LOGIN}/oauth/wx`,param)
}

/**
 * 渠道信息
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function agentChannel(channelCode) {
    return get(`${BASE_URL}/ext/agent/channel/${channelCode}`)
}